import { useTranslation } from 'react-i18next';
import { useSuspenseQuery } from '@tanstack/react-query';

import { usePlatform } from '../../../../context/PlatformContext';
import { useRouteParams } from '../../../../router/router-hooks';
import { PageSection } from '../../../components/PageSection/PageSection';
import { PremiumBreakdown } from '../../../components/PremiumBreakdown/PremiumBreakdown';
import { policiesQueries } from '../../network/queries';
import { type PolicyRouteParams } from '../PolicyDetailsPage';

export function PolicyPriceBreakdown() {
  const { params } = useRouteParams<PolicyRouteParams>();
  const { policyId } = params;
  const { data: policy } = useSuspenseQuery(
    policiesQueries.details({ policyId }),
  );
  const { t } = useTranslation();
  const { platform } = usePlatform();

  if (!policy?.quote) {
    return null;
  }

  const {
    premium_value,
    premium_currency,
    premium_rate,
    premium_war_rate,
    tax,
    exchange_rate,
    converted_customer_premium_value,
    converted_tax_amount,
    distributor,
  } = policy.quote;

  if (!premium_value || !premium_currency) {
    return null;
  }

  return (
    <PageSection
      title={t('PriceDetails', {
        ns: 'common',
        context: platform,
      })}
      className="flex flex-col shrink grow-0 basis-[300px]"
    >
      <PremiumBreakdown
        showPremiumInPdf={policy.show_premiums_in_pdf}
        premium_value={premium_value}
        premium_currency={premium_currency}
        premium_rate={premium_rate}
        premium_war_rate={premium_war_rate}
        tax={tax}
        exchange_rate={exchange_rate}
        converted_customer_premium_value={converted_customer_premium_value}
        converted_tax_amount={converted_tax_amount}
        hide_tax_info={distributor?.hide_tax_info}
        distributor_net_cost_value={policy.quote.distributor_net_cost_value}
        distributor_net_cost_currency={
          policy.quote.distributor_net_cost_currency
        }
        componentProps={{
          components: { currency: { level: 'base' } },
          total: { title: { level: 'h5' }, currency: { level: 'h2' } },
        }}
      />
    </PageSection>
  );
}
